import { render, staticRenderFns } from "./LoaderIcon.vue?vue&type=template&id=b25acc60"
import script from "./LoaderIcon.vue?vue&type=script&lang=js"
export * from "./LoaderIcon.vue?vue&type=script&lang=js"
import style0 from "./LoaderIcon.vue?vue&type=style&index=0&id=b25acc60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports